import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PolicySource } from "../../type/chat";
import { parseCitationChildren } from "../../utils/parse-citation-children";
import "./index.scss";

interface MarkdownTextProps {
  text: string;
  policySources?: PolicySource[];
}

const MarkdownText: React.FC<MarkdownTextProps> = ({ text, policySources }) => {
  const cite = (children: React.ReactNode) =>
    parseCitationChildren(children, policySources);

  return (
    <div className="markdown-text">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children, ...props }) => (
            <a {...props} target="_blank">
              {children}
            </a>
          ),
          p: ({ children }) => <p>{cite(children)}</p>,
          li: ({ children, ...props }) => <li {...props}>{cite(children)}</li>,
          td: ({ children, ...props }) => <td {...props}>{cite(children)}</td>,
          th: ({ children, ...props }) => <th {...props}>{cite(children)}</th>,
          h1: ({ children }) => <h1>{cite(children)}</h1>,
          h2: ({ children }) => <h2>{cite(children)}</h2>,
          h3: ({ children }) => <h3>{cite(children)}</h3>,
          // code / pre intentionally NOT overridden — [n] inside code blocks stays literal
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
